<h1 class="text-center m-0">Nouvelle intervention </h1>
<div class="mt-4 p-3 pt-0">

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Type</mat-label>
            <mat-select placeholder="Type" [(ngModel)]="Model.Type" required>
                <mat-option *ngFor="let int of InterventionTypeList; let i = index" [value]="int.idx">
                    <span>{{int.s}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col">
            <mat-label>Groupement Prelevement/Analyse</mat-label>
            <mat-select placeholder="Groupement Prelevement/Analyse" [(ngModel)]="Model.GroupementAnalyse" required>
                <mat-option *ngFor="let g of GroupementAnalyseList; let i = index" [value]="g.idx">
                    <span>{{g.s}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Préleveur</mat-label>
            <mat-select placeholder="Préleveur " [(ngModel)]="Model.SamplerPuid" [compareWith]="compareUser" required>
                <mat-option *ngFor="let u of AllUserList" [value]="u.Code">
                    <span>{{u.Fullname}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col">
            <mat-label>Responsable</mat-label>
            <mat-select placeholder="Responsable" [(ngModel)]="Model.ResponsiblePuid" [compareWith]="compareUser" required>
                <mat-option *ngFor="let u of AllUserList" [value]="u.Code">
                    <span>{{u.Fullname}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Station Name</mat-label>
                <input matInput placeholder="Station Name" [(ngModel)]="Model.StationName">
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
            Annuler<mat-icon>undo</mat-icon>
        </button>
        <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
            Enregistrer<mat-icon>save</mat-icon>
        </button>
    </div>
</div>